export interface DevisLineItem {
  id: string;
  /** Empty for personal (non-catalog) articles. */
  product_id: string;
  designation: string;
  quantity: number;
  unit_price: number;
  /** Personal article created only for this devis (not saved to products). */
  isCustom?: boolean;
  /** Display name for custom articles (or product name cache). */
  name?: string;
  /** Product / custom description shown on the PDF under the name. */
  description?: string;
  /** Optional image as data URL / public URL for UI + PDF thumb. */
  image?: string;
}

export interface DevisDraft {
  clientName: string;
  clientAddress: string;
  clientMatricule: string;
  serialNumber: string;
  date: string; // dd/MM/yyyy
  /** Fixed discount amount in HT (not a percentage). */
  discount: number;
  items: DevisLineItem[];
}

export interface DevisTotals {
  totalHt: number;
  discountAmount: number;
  totalAfterDiscount: number;
}

export const DEVIS_COMPANY = {
  name: 'Sté Meubles Karim',
  tagline: 'Productions de Meubles',
  address: 'Avenue Abou Dhabi 8050 Hammamet',
  phone: 'Tél : +216 96 275 131',
  email: 'E-mail : meubleskarim019@gmail.com',
} as const;
